import axios from 'axios';

export const postSolutionList = (params) => {
  return axios.post('/api/internal/solution/list', params);
};

export const getSolutionDetail = (id) => {
  return axios.get(`/api/internal/solution/${id}`);
};
